import _defineProperty from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import selectPerson from '@/components/select-person';
import config from '@/pathConfig';
import { addDocumentFill, getDocumentFillDataById, editDocumentFillById, documentFillSubmit, saveDocumentPenPaper } from '@/api/notice/documentApi.js';
var Base64 = require('js-base64').Base64;
export default {
  data: function data() {
    var validateMainDelivery = function validateMainDelivery(rule, value, callback) {
      if (value.organData.length === 0 && value.postData.length === 0 && value.userData.length === 0) {
        callback(new Error('请选择主送'));
      } else {
        callback();
      }
    };
    var validateCopyDelivery = function validateCopyDelivery(rule, value, callback) {
      if (value.organData.length === 0 && value.postData.length === 0 && value.userData.length === 0) {
        callback(new Error('请选择主送'));
      } else {
        callback();
      }
    };
    return {
      userInfo: this.$hdk.userInfo.get(),
      options: [],
      form: {
        tempId: -1,
        id: undefined,
        urgency: undefined,
        secretLevel: undefined,
        fileList: [],
        fileNameGroup: [],
        organPostId: [],
        copyDelivery: {
          organData: [],
          postData: [],
          userData: [],
          organId: 0,
          postId: 0
        },
        csNameList: [],
        mainDelivery: {
          organData: [],
          postData: [],
          userData: [],
          organId: 0,
          postId: 0
        },
        zsNameList: [],
        fileName: '',
        fileCode: '',
        formDate: '',
        isEmergent: 0
      },
      mode: undefined,
      previewSrc: '',
      previewShow: false,
      headers: {},
      rules1: {
        organPostId: [{
          required: true,
          message: '请选择所属组织及岗位',
          trigger: 'change'
        }],
        fileName: [{
          required: true,
          message: '请输入文件名称',
          trigger: 'blur'
        }],
        // fileCode: [
        //     {
        //         required: true,
        //         message: '请输入文件编号',
        //         trigger: 'blur'
        //     }
        // ],
        // secretLevel: [
        //     {
        //         required: true,
        //         message: '请输入密级',
        //         trigger: 'blur'
        //     }
        // ],
        // urgency: [
        //     {
        //         required: true,
        //         message: '请输入缓急',
        //         trigger: 'blur'
        //     }
        // ],

        mainDelivery: [{
          required: true,
          message: '请选择主送',
          trigger: 'change',
          validator: validateMainDelivery
        }]
        // copyDelivery: [
        //     {
        //         required: true,
        //         message: '请选择抄送',
        //         trigger: 'change',
        //         validator: validateCopyDelivery
        //     }
        // ]
      },
      rules2: _defineProperty({
        organPostId: [{
          required: true,
          message: '请选择所属组织及岗位',
          trigger: 'change'
        }],
        fileName: [{
          required: true,
          message: '请输入标题',
          trigger: 'blur'
        }],
        copyDelivery: [{
          required: true,
          message: '请选择抄送',
          trigger: 'change',
          validator: validateCopyDelivery
        }]
      }, "fileName", [{
        required: true,
        message: '请输入公文标题',
        trigger: 'blur'
      }])
    };
  },
  watch: {
    'form.mainDelivery': function formMainDelivery(n, o) {
      this.form.zsNameList = [];
      if (n.organData) {
        var organData = n.organData;
        if (organData.length > 0) {
          for (var i = 0; i < organData.length; i++) {
            this.form.zsNameList.push(organData[i].name);
          }
        }
      }
      if (n.postData) {
        var postData = n.postData;
        if (postData.length > 0) {
          for (var i = 0; i < postData.length; i++) {
            this.form.zsNameList.push(postData[i].name);
          }
        }
      }
      if (n.userData) {
        var userData = n.userData;
        if (userData.length > 0) {
          for (var i = 0; i < userData.length; i++) {
            this.form.zsNameList.push(userData[i].name);
          }
        }
      }
    },
    'form.copyDelivery': function formCopyDelivery(n, o) {
      this.form.csNameList = [];
      if (n.organData) {
        var organData = n.organData;
        if (organData.length > 0) {
          for (var i = 0; i < organData.length; i++) {
            this.form.csNameList.push(organData[i].name);
          }
        }
      }
      if (n.postData) {
        var postData = n.postData;
        if (postData.length > 0) {
          for (var i = 0; i < postData.length; i++) {
            this.form.csNameList.push(postData[i].name);
          }
        }
      }
      if (n.userData) {
        var userData = n.userData;
        if (userData.length > 0) {
          for (var i = 0; i < userData.length; i++) {
            this.form.csNameList.push(userData[i].name);
          }
        }
      }
    },
    'form.fileList': function formFileList(n, o) {
      if (n.length > 0) {
        this.form.fileNameGroup = [];
        for (var i = 0; i < n.length; i++) {
          this.form.fileNameGroup.push(n[i].name);
        }
      }
    }
  },
  components: {
    selectPerson: selectPerson
  },
  methods: {
    /**
     * 级联选择
     */
    onOrganAndJob: function onOrganAndJob(value, option) {
      // const { $set, formObject, getOrganByUser } = this;
      // 组织岗位赋值
      // $set(formObject, 'organId', value[0]);
      // $set(formObject, 'postId', value[1]);
      // $set(formObject, 'typeId', option[0].typeId);
      // this.formObject.customize = {};
      // this.formObject.customize.organId = value[0];
      // this.formObject.customize.postId = value[1];
      this.form.mainDelivery.organId = value[0];
      this.form.mainDelivery.postId = value[1];
      this.form.copyDelivery.organId = value[0];
      this.form.copyDelivery.postId = value[1];
    },
    backPage: function backPage() {
      this.$router.push({
        path: '/docNotice/doc/send'
      });
    },
    handleChangeUpload: function handleChangeUpload(info) {
      if (info.file.status == 'removed') {
        this.$message.success('删除');
        this.form.fileList = info.fileList;
        this.previewSrc = '';
        this.previewShow = false;
        return;
      }
      this.form.fileList = info.fileList;
      if (info.file.response) {
        if (info.file.response.code == 200) {
          this.form.fileList = info.fileList;
          this.$message.success('上传成功');
        } else {
          this.$message.error(info.file.response.message);
        }
      }
    },
    handlePreview: function handlePreview(file) {
      var url = file.response.data.url;
      var fileUrl = config.baseUrl + url;
      window.open(config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl)), '_blank');

      // this.previewShow = true;
      // this.previewSrc =
      //     config.filePreview + '?url=' + encodeURIComponent(Base64.encode(fileUrl));
    },
    handleCancel: function handleCancel() {
      this.previewShow = false;
    },
    submit: function submit() {
      var that = this;
      var data = {
        annexFileList: []
      };
      Object.assign(data, this.form);
      var fileList = data.fileList;
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          data.annexFileList.push({
            annexname: fileList[i].name,
            annexpath: fileList[i].response.data.url
          });
        }
      }
      data.mainDelivery = this.assemblyData(this.form.mainDelivery);
      data.copyDelivery = this.assemblyData(this.form.copyDelivery);
      var req = {
        fileCode: data.fileCode,
        fileName: data.fileName,
        tempId: data.tempId,
        urgency: data.urgency,
        secretLevel: data.secretLevel,
        mainDelivery: data.mainDelivery,
        copyDelivery: data.copyDelivery,
        annexFileList: data.annexFileList,
        isEmergent: this.form.isEmergent,
        organId: this.form.mainDelivery.organId === 0 ? this.form.copyDelivery.organId : this.form.mainDelivery.organId,
        postId: this.form.mainDelivery.postId === 0 ? this.form.copyDelivery.postId : this.form.mainDelivery.postId,
        docData: {
          filecode: data.fileCode,
          filename: data.fileName,
          tempid: data.tempId,
          urgency: data.urgency,
          secretlevel: data.secretLevel,
          maindelivery: data.mainDelivery,
          copydelivery: data.copyDelivery,
          annexfilelist: data.annexFileList,
          date: this.form.formDate,
          isEmergent: this.form.isEmergent
        }
      };
      if (this.form.tempId != 4) {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            addDocumentFill(req).then(function (res) {
              if (res.data.code === 200) {
                that.$message.success('保存成功');
                that.backPage();
              }
            });
          } else {
            return false;
          }
        });
      } else {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            saveDocumentPenPaper(req).then(function (res) {
              if (res.data.code === 200) {
                that.$message.success('保存成功');
                that.backPage();
              }
            });
          } else {
            return false;
          }
        });
      }
    },
    editSubmit: function editSubmit() {
      var that = this;
      var data = {
        annexFileList: []
      };
      Object.assign(data, this.form);
      var fileList = data.fileList;
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          data.annexFileList.push({
            annexname: fileList[i].name,
            annexpath: fileList[i].response.data.url
          });
        }
      }
      data.mainDelivery = this.assemblyData(this.form.mainDelivery);
      data.copyDelivery = this.assemblyData(this.form.copyDelivery);
      var req = {
        id: data.id,
        fileCode: data.fileCode,
        fileName: data.fileName,
        tempId: data.tempId,
        urgency: data.urgency,
        secretLevel: data.secretLevel,
        mainDelivery: data.mainDelivery,
        copyDelivery: data.copyDelivery,
        annexFileList: data.annexFileList,
        isEmergent: this.form.isEmergent,
        organId: this.form.mainDelivery.organId === 0 ? this.form.copyDelivery.organId : this.form.mainDelivery.organId,
        postId: this.form.mainDelivery.postId === 0 ? this.form.copyDelivery.postId : this.form.mainDelivery.postId,
        docData: {
          filecode: data.fileCode,
          filename: data.fileName,
          tempid: data.tempId,
          urgency: data.urgency,
          secretlevel: data.secretLevel,
          maindelivery: data.mainDelivery,
          copydelivery: data.copyDelivery,
          annexfilelist: data.annexFileList,
          date: this.form.formDate,
          isEmergent: this.form.isEmergent
        }
      };
      this.$refs.form.validate(function (valid) {
        if (valid) {
          editDocumentFillById(req).then(function (res) {
            if (res.data.code === 200) {
              that.$message.success('编辑成功');
              that.backPage();
            }
          });
        } else {
          return false;
        }
      });
    },
    submitAndAudit: function submitAndAudit() {
      var that = this;
      var data = {
        annexFileList: []
      };
      Object.assign(data, this.form);
      var fileList = data.fileList;
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          data.annexFileList.push({
            annexname: fileList[i].name,
            annexpath: fileList[i].response.data.url
          });
        }
      }
      data.mainDelivery = this.assemblyData(this.form.mainDelivery);
      data.copyDelivery = this.assemblyData(this.form.copyDelivery);
      var req = {
        fileCode: data.fileCode,
        fileName: data.fileName,
        tempId: data.tempId,
        urgency: data.urgency,
        secretLevel: data.secretLevel,
        mainDelivery: data.mainDelivery,
        copyDelivery: data.copyDelivery,
        annexFileList: data.annexFileList,
        isEmergent: this.form.isEmergent,
        organId: this.form.mainDelivery.organId === 0 ? this.form.copyDelivery.organId : this.form.mainDelivery.organId,
        postId: this.form.mainDelivery.postId === 0 ? this.form.copyDelivery.postId : this.form.mainDelivery.postId,
        docData: {
          filecode: data.fileCode,
          filename: data.fileName,
          tempid: data.tempId,
          urgency: data.urgency,
          secretlevel: data.secretLevel,
          maindelivery: data.mainDelivery,
          copydelivery: data.copyDelivery,
          annexfilelist: data.annexFileList,
          date: this.form.formDate,
          isEmergent: this.form.isEmergent
        }
      };
      if (this.form.tempId != 4) {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            addDocumentFill(req).then(function (res) {
              if (res.data.code === 200) {
                var reqq = {
                  id: res.data.data,
                  tempId: req.tempId,
                  releaseOrganId: req.organId,
                  releasePostId: req.postId
                };
                documentFillSubmit(reqq).then(function (ress) {
                  if (ress.data.code == 200) {
                    that.$message.success('保存并提交成功');
                    that.backPage();
                  } else {
                    that.backPage();
                  }
                });
              }
            });
          } else {
            return false;
          }
        });
      } else {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            saveDocumentPenPaper(req).then(function (res) {
              if (res.data.code === 200) {
                var reqq = {
                  id: res.data.data,
                  tempId: req.tempId,
                  releaseOrganId: req.organId,
                  releasePostId: req.postId
                };
                documentFillSubmit(reqq).then(function (ress) {
                  if (ress.data.code == 200) {
                    that.$message.success('保存并提交成功');
                    that.backPage();
                  } else {
                    that.backPage();
                  }
                });
              }
            });
          } else {
            return false;
          }
        });
      }
    },
    editAndAudit: function editAndAudit() {
      var that = this;
      var data = {
        annexFileList: []
      };
      Object.assign(data, this.form);
      var fileList = data.fileList;
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          data.annexFileList.push({
            annexname: fileList[i].name,
            annexpath: fileList[i].response.data.url
          });
        }
      }
      data.mainDelivery = this.assemblyData(this.form.mainDelivery);
      data.copyDelivery = this.assemblyData(this.form.copyDelivery);
      var req = {
        id: data.id,
        fileCode: data.fileCode,
        fileName: data.fileName,
        tempId: data.tempId,
        urgency: data.urgency,
        secretLevel: data.secretLevel,
        mainDelivery: data.mainDelivery,
        copyDelivery: data.copyDelivery,
        annexFileList: data.annexFileList,
        isEmergent: this.form.isEmergent,
        organId: this.form.mainDelivery.organId === 0 ? this.form.copyDelivery.organId : this.form.mainDelivery.organId,
        postId: this.form.mainDelivery.postId === 0 ? this.form.copyDelivery.postId : this.form.mainDelivery.postId,
        docData: {
          filecode: data.fileCode,
          filename: data.fileName,
          tempid: data.tempId,
          urgency: data.urgency,
          secretlevel: data.secretLevel,
          maindelivery: data.mainDelivery,
          copydelivery: data.copyDelivery,
          annexfilelist: data.annexFileList,
          date: this.form.formDate,
          isEmergent: this.form.isEmergent
        }
      };
      if (this.form.tempId != 4) {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            editDocumentFillById(req).then(function (res) {
              if (res.data.code === 200) {
                var reqq = {
                  id: req.id,
                  tempId: req.tempId,
                  releaseOrganId: req.organId,
                  releasePostId: req.postId
                };
                documentFillSubmit(reqq).then(function (ress) {
                  if (ress.data.code == 200) {
                    that.$message.success('编辑并提交成功');
                    that.backPage();
                  } else {
                    that.backPage();
                  }
                });
              }
            });
          } else {
            return false;
          }
        });
      } else {
        this.$refs.form.validate(function (valid) {
          if (valid) {
            editDocumentFillById(req).then(function (res) {
              if (res.data.code === 200) {
                var reqq = {
                  id: req.id,
                  tempId: req.tempId,
                  releaseOrganId: req.organId,
                  releasePostId: req.postId
                };
                documentFillSubmit(reqq).then(function (ress) {
                  if (ress.data.code == 200) {
                    that.$message.success('编辑并提交成功');
                    that.backPage();
                  } else {
                    that.backPage();
                  }
                });
              }
            });
          } else {
            return false;
          }
        });
      }
    },
    assemblyData: function assemblyData(source) {
      var data = [];
      var mainOrgan = source.organData,
        mainPost = source.postData,
        mainUser = source.userData;
      if (mainOrgan.length > 0) {
        for (var i = 0; i < mainOrgan.length; i++) {
          data.push({
            organid: mainOrgan[i].id,
            typeid: mainOrgan[i].typeId
          });
        }
      }
      if (mainPost.length > 0) {
        for (var i = 0; i < mainPost.length; i++) {
          data.push({
            postid: mainPost[i].id,
            typeid: mainPost[i].type
          });
        }
      }
      if (mainUser.length > 0) {
        for (var i = 0; i < mainUser.length; i++) {
          data.push({
            userid: mainUser[i].id,
            typeid: mainUser[i].type
          });
        }
      }
      return data;
    },
    filterOption: function filterOption(inputValue, path) {
      return path.some(function (option) {
        return option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      }) || path.some(function (option) {
        return option.value.toLowerCase().indexOf(inputValue.toLowerCase()) > -1;
      });
    }
  },
  mounted: function mounted() {
    var _this = this;
    var that = this;
    that.headers = {
      Authorization: sessionStorage.getItem('token')
    };
    var query = this.$route.query;
    this.mode = query.mode;
    var userInfo = this.userInfo;
    this.options = _.map(userInfo.organPostTree, function (item) {
      item.postList = _.map(item.postList, function (subItem) {
        return {
          label: subItem.postName,
          value: subItem.postId,
          children: null
        };
      });
      return {
        label: item.organName,
        value: item.organId,
        children: item.postList
      };
    });
    if (this.mode == 'add') {
      this.form.tempId = query.tempId;
    } else {
      Object.assign(this.form, query.data);
      getDocumentFillDataById(this.form).then(function (res) {
        if (res.data.code == 200) {
          var docData = JSON.parse(res.data.data.docData.value);
          _this.form.signImgUrl = docData.draftmanpath;
          //   this.form.signImgUrl = config.baseUrl + docData.draftmanpath;
          _this.form.organPostId[0] = _this.form.organId;
          _this.form.organPostId[1] = _this.form.postId;
          if (docData.date) {
            _this.form.formDate = docData.date;
          }
          // this.form.cascaderVal[0] = this.form.organId;
          // this.form.cascaderVal[1] = this.form.postId;
          if (docData.annexfilelist.length > 0) {
            for (var i = 0; i < docData.annexfilelist.length; i++) {
              that.form.fileList.push({
                uid: i,
                url: docData.annexfilelist[i].annexpath,
                //  url: config.baseUrl + docData.annexfilelist[i].annexpath,
                name: docData.annexfilelist[i].annexname,
                response: {
                  data: {
                    url: docData.annexfilelist[i].annexpath
                  }
                }
              });
            }
          }
          var mainDelivery = res.data.data.sendScope.mainDelivery,
            copyDelivery = res.data.data.sendScope.copyDelivery;
          that.form.mainDelivery.organData = [];
          if (mainDelivery.organData.length > 0) {
            for (var i = 0; i < mainDelivery.organData.length; i++) {
              that.form.mainDelivery.organData.push({
                id: mainDelivery.organData[i].organid,
                name: mainDelivery.organData[i].organname,
                typeId: mainDelivery.organData[i].typeid
              });
            }
          }
          if (mainDelivery.postData.length > 0) {
            for (var i = 0; i < mainDelivery.postData.length; i++) {
              that.form.mainDelivery.postData.push({
                id: mainDelivery.postData[i].postid,
                name: mainDelivery.postData[i].postname,
                type: mainDelivery.postData[i].typeid
              });
            }
          }
          if (mainDelivery.userData.length > 0) {
            for (var i = 0; i < mainDelivery.userData.length; i++) {
              that.form.mainDelivery.userData.push({
                id: mainDelivery.userData[i].userid,
                name: mainDelivery.userData[i].username,
                type: mainDelivery.userData[i].typeid
              });
            }
          }
          if (copyDelivery.organData.length > 0) {
            for (var i = 0; i < copyDelivery.organData.length; i++) {
              that.form.copyDelivery.organData.push({
                id: copyDelivery.organData[i].organid,
                name: copyDelivery.organData[i].organname,
                typeId: copyDelivery.organData[i].typeid
              });
            }
          }
          if (copyDelivery.postData.length > 0) {
            for (var i = 0; i < copyDelivery.postData.length; i++) {
              that.form.copyDelivery.postData.push({
                id: copyDelivery.postData[i].postid,
                name: copyDelivery.postData[i].postname,
                type: copyDelivery.postData[i].typeid
              });
            }
          }
          if (copyDelivery.userData.length > 0) {
            for (var i = 0; i < copyDelivery.userData.length; i++) {
              that.form.copyDelivery.userData.push({
                id: copyDelivery.userData[i].userid,
                name: copyDelivery.userData[i].username,
                type: copyDelivery.userData[i].typeid
              });
            }
          }
          _this.form.mainDelivery = JSON.parse(JSON.stringify(_this.form.mainDelivery));
          _this.form.copyDelivery = JSON.parse(JSON.stringify(_this.form.copyDelivery));
          _this.form.mainDelivery.organId = _this.form.organId;
          _this.form.mainDelivery.postId = _this.form.postId;
          _this.form.copyDelivery.organId = _this.form.organId;
          _this.form.copyDelivery.postId = _this.form.postId;
        }
      });
    }
  }
};